import AffiliatePanel from '../dashboard/pages/SettingsPage/AffiliatePanel/AffiliatePanel';
import BillingPanel from '../dashboard/pages/SettingsPage/BillingPanel/BillingPanel';
import { CancellationPanel } from '../dashboard/pages/SettingsPage/BillingPanel/CancellationPanel/CancellationPanel';
import InvoicesPanel from '../dashboard/pages/SettingsPage/BillingPanel/InvoicesPanel/InvoicesPanel';
import { CompanyPanel } from '../dashboard/pages/SettingsPage/CompanyPanel/CompanyPanel';
import { MyAccountPanel } from '../dashboard/pages/SettingsPage/MyAccountPanel/MyAccountPanel';
import UsersPanel from '../dashboard/pages/SettingsPage/UsersPanel/UsersPanel';
import UserEditor from '../dashboard/pages/UserEditor/UserEditor';

const BILLING_PATH_ROOT = '/settings/billing';

export const SettingsRoutes = {
  myAccount: {
    path: '/settings/my-account',
    component: MyAccountPanel,
    getLink: () => {
      return '/settings/my-account';
    },
  },
  company: {
    path: '/settings/company',
    component: CompanyPanel,
    getLink: () => {
      return '/settings/company';
    },
  },
  billing: {
    path: BILLING_PATH_ROOT,
    component: BillingPanel,
    getLink: () => {
      return BILLING_PATH_ROOT;
    },

    // Nested Routes
    invoices: {
      path: `${BILLING_PATH_ROOT}/invoices`,
      component: InvoicesPanel,
      getLink: () => {
        return `${BILLING_PATH_ROOT}/invoices`;
      },
    },
    cancel: {
      path: `${BILLING_PATH_ROOT}/cancel/:tabId/:pageId`,
      component: CancellationPanel,
      getLink: (tabId: string, pageId: number) => {
        return `${BILLING_PATH_ROOT}/cancel/${tabId}/${pageId}`;
      },
    },
  },
  users: {
    path: '/settings/users',
    component: UsersPanel,
    getLink: () => {
      return '/settings/users';
    },
  },
  editUser: {
    path: `/company/:companyId/users/:userId/edit`,
    component: UserEditor,
    getLink: ({ companyId, userId }: { companyId: number; userId: number }) => {
      return `/company/${companyId}/users/${userId}/edit`;
    },
  },
  affiliates: {
    path: '/settings/referrals',
    component: AffiliatePanel,
    getLink: () => {
      return '/settings/referrals';
    },
  },
};
